<template>
  <div
    id="app"
    :class="['y_'+global.year.slice(0,4), global.limitYear <= global.year ? 'year_after' : 'year_before']"
    :style="global.limitYear <= global.year ?
      `--header-height-pc: ${global.header_height_pc}; --header-height-mob: ${global.header_height_mob};` :
      ''"
  >
    <!-- <img src="./assets/logo.png"> -->
    <!-- 导航 -->
    <slot v-if="!($route.meta && $route.meta.isbase)">
      <Header v-if="global.year>=global.limitYear"></Header>
      <Headall v-else></Headall>
    </slot>
    <!-- 路由 -- 缓存组件? -->
    <keep-alive v-if="$route.meta.keepAlive">
      <router-view />
    </keep-alive>
    <router-view v-else />
    <!-- 页脚 -->
    <slot v-if="!($route.meta && $route.meta.isbase)">
      <Footer v-if="global.year>=global.limitYear"></Footer>
      <Footall v-else></Footall>
      <slot v-if="!($route.name&&($route.name.includes('Order')||$route.name.includes('Code'))) && $route.name.toLowerCase().indexOf('live')==-1">
        <BottomN v-if="global.limitYear<=global.year"></BottomN>
        <Bottom v-else></Bottom>
      </slot>
    </slot>
    <!-- <button-foot v-if="$route.name != 'Order'"></button-foot> -->
  </div>
</template>

<script>
import { mixinSession } from '@/mixin'
import Headall from '@/components/Headall.vue'
import Header from '@/componentsNew/Header.vue'
import Footall from '@/components/Footall.vue'
import Footer from '@/componentsNew/Footer.vue'
import ButtonFoot from '@/components/ButtonFoot.vue'
import Bottom from '@/components/Bottom.vue'
import BottomN from '@/componentsNew/Bottom.vue'

export default {
  name: 'App',
  mixins: [mixinSession],
  components: {
    Headall,
    Header,
    Footall,
    Footer,
    ButtonFoot,
    Bottom,
    BottomN
  },
  created () {
    // 取消部分setItem
    if (localStorage.getItem('sid')) {
      localStorage.removeItem('sid')
    }
    if (localStorage.getItem('qd')) {
      localStorage.removeItem('qd')
    }
    // if(localStorage.getItem('share')){
    //   localStorage.removeItem('share');
    // }

    this.getHash()
  },
  watch: {
    // '$route' (to, from) { //监听路由是否变化
    //   // console.log(to,"   ",from);
    //   // if(to.fullPath != from.fullPath){
    //   //   location.reload();
    //   // }
    // }
    $route: {
      handler (to, from) {
        // console.log('------ ', to, from)
        if (!from || from.fullPath === '/') {
          window.localStorage.removeItem('linkurl')
        }
        // '/order'
        if (to && to.path === '/order') {
          this.checkUserInfo('/order')
        }
        // sid
        if (to && to.query && to.query.sid) {
          // console.log('app-r- ', from && from.query && from.query.sid, to, this.global.area_id, this.global.config[to.query.sid].year)
          // this.global.area_id = to.query.sid || this.$route.query.sid
          // this.global.year = (this.global.config[this.global.area_id] && this.global.config[this.global.area_id].year) || new Date().getFullYear()
          // this.global.year = this.global.year.trim()
          // this.$forceUpdate()
          let _path = to.query.fullPath && to.query.fullPath.split('?')[1] ? ('?' + to.query.fullPath.split('?')[1]) : ''
          this.getHash(_path)
          if (from && from.query && from.query.sid !== to.query.sid) {
            window.location.reload()
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getHash (_path) {
      this.global.getHash(_path || '')
      // console.log('param: ',this.global.hashParam);

      if (this.global.hashParam['sid']) {
        this.global.area_id = this.global.hashParam['sid']
        this.global.year = (this.global.config[this.global.area_id] && this.global.config[this.global.area_id].year) || new Date().getFullYear()
        this.global.year = this.global.year.trim()
        this.global.address = this.global.config[this.global.area_id] && (this.global.config[this.global.area_id].address || (this.global.year + (this.global.config[this.global.area_id].jieshu || this.global.area_id)))
        this.global.address = this.global.address.trim()
        if (this.global.hashParam['sid'] < '2252') { // before 2021
          // const staticPath = {path: `../static/2020MPD/index.html?sid=${this.global.hashParam['sid']}`}
          // this.$router.push(staticPath)
          // location.reload()
          window.open(`/static/2020MPD/index.html?sid=${this.global.hashParam['sid']}`, '_self')
        }
      }
      if (this.global.hashParam['qd']) {
        this.global.qd = this.global.hashParam['qd']
      }
      if (this.global.hashParam['share']) {
        this.global.share_id = this.global.hashParam['share']
      }

      // console.log('app- ', this.global.year, this.global.area_id)
    },

    // 检查用户状态（是否存在/是否登录/登录状态是否过期）
    checkUserInfo (_path) {
      const token = window.localStorage.getItem('token')
      if (token && token !== null) {
        let url = `${this.global.url.user.info}?token=${token}`
        this.$http
          .jsonp(url)
          .then((data) => {
            return data.json()
          })
          .then((res) => {
            // console.log('check_userInfo ', res)
            if (res.status === '200') {
              for (const key in res.data) {
                if (res.data[key] === '') {
                  let tip = _path === '/order' ? '购票需要您先完善个人信息' : '请先完善个人信息'
                  if (window.confirm(tip)) {
                    this.$router.push(this.formatHref('/user_center', { active: '5' }))
                  }
                  break
                }
              }
            } else if (res.code === '1001' || res.status === '1011') {
              this.$message.closeAll()
              this.$message({ message: '当前登录状态已过期，请重新登录', type: 'warning' })
              window.localStorage.removeItem('logins')
              window.localStorage.removeItem('token')
              let order = _path + `${this.global.hashParam.qd ? '?qd=' + this.global.hashParam.qd : ''}`
              window.localStorage.setItem('linkurl', order)
              setTimeout(() => {
                this.$router.push(this.formatHref('/login', {sid: this.global.area_id}))
              }, 800)
            } else {
              console.log('获取用户信息失败')
            }
          })
      } else {
        this.$message.closeAll()
        this.$message({ message: '当前登录状态已过期，请重新登录', type: 'warning' })
        window.localStorage.removeItem('logins')
        window.localStorage.removeItem('token')
        let order = _path + `${this.global.hashParam.qd ? '?qd=' + this.global.hashParam.qd : ''}`
        window.localStorage.setItem('linkurl', order)
        setTimeout(() => {
          this.$router.push(this.formatHref('/login', {sid: this.global.area_id}))
        }, 800)
      }
    }
  }
}
</script>

<style lang="scss">
@import "common/css/bootstrap.min.css";
@import "common/css/animate.css";
@import "common/css/main.scss";

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000000;
  /* text-align: center; */
  /* margin-top: 60px; */
}

.pc {
  display: block;
}

.mob {
  display: none;
}

@media (min-width: 200px) and (max-width:767px) {
  .pc {
    display: none!important;
  }
  .mob {
    display: block
  }
}

.pc_about {
  display: block;
}

.mob_about {
  display: none;
}

@media (min-width: 200px) and (max-width:995px) {
  .pc_about {
    display: none!important;
  }
  .mob_about {
    display: block
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue